import { render, staticRenderFns } from "./SAASBMap.vue?vue&type=template&id=08553be3"
import script from "./SAASBMap.vue?vue&type=script&lang=js"
export * from "./SAASBMap.vue?vue&type=script&lang=js"
import style0 from "./SAASBMap.vue?vue&type=style&index=0&id=08553be3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports